import { Link } from "react-router";
import { describeActivity } from "../lib/activity.ts";
import { clock, fullTime } from "../lib/format.ts";
import type { ActivityItem } from "../lib/types.ts";

export function ActivityFeed({ items, showProject = true }: { items: ActivityItem[]; showProject?: boolean }) {
  const lines = items.map((it) => ({ it, line: describeActivity(it) })).filter((x) => x.line);
  if (!lines.length) return <div className="muted small">Nothing yet.</div>;
  return (
    <div className="stack tight">
      {lines.map(({ it, line }) => (
        <div key={it.id} className="row nowrap" style={{ alignItems: "baseline" }}>
          <time className="mono muted small" title={fullTime(it.createdAt)} style={{ width: 92, flex: "none" }}>
            {clock(it.createdAt)}
          </time>
          <i className={`dot ${line!.tone === "muted" ? "" : line!.tone}`} style={{ alignSelf: "center" }} />
          <span className="grow small" style={{ overflowWrap: "anywhere" }}>
            <Link to={`/sessions/${it.sessionId}`}>
              <b>{it.sessionName}</b>
            </Link>
            {showProject && <span className="muted"> ({it.projectSlug})</span>} {line!.text}
          </span>
        </div>
      ))}
    </div>
  );
}
